import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../../../shared/shared.module';
import { StationInfoComponent } from './station-info/station-info.component';
import { NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';
import { StationTableComponent } from './station-table/station-table.component';
import { OverlayPanelModule } from '../../../components/overlay-panel/overlay-panel.module';

@NgModule({
  imports: [
    NgbTabsetModule,
    OverlayPanelModule,
    SharedProviderModule
  ],
  declarations: [StationInfoComponent, StationTableComponent],
  exports: [StationInfoComponent]
})
export class StationInfoModule {
}
